// src/components/cierreGeneral/AccountsPayablePanel.jsx
import React from 'react';

// Formato colones (₡)
function formatCRC(value) {
  const n = Number(value || 0);
  return n.toLocaleString('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 2,
  });
}

function StatCard({ title, main, subtitle, footer }) {
  return (
    <div className="cg-card cg-card-inner">
      <div className="cg-card-title">{title}</div>
      <div className="cg-card-value">{main}</div>
      {subtitle ? <div className="cg-card-sub">{subtitle}</div> : null}
      {footer ? (
        <>
          <div className="cg-divider" />
          <div className="cg-muted">{footer}</div>
        </>
      ) : null}
    </div>
  );
}

export default function AccountsPayablePanel({ data }) {
  const ap = data?.accountsPayable || {};

  const topInv = ap?.topInvoicesSupplier;
  const topPay = ap?.topPaymentsSupplier;
  const biggest = ap?.biggestPayableSupplier;

  return (
    <div className="cg-section">
      <div className="cg-section-header">
        <h3 className="cg-section-title">Cuentas por pagar (proveedores)</h3>
        <div className="cg-muted">
          Resumen basado en facturas, pagos y saldo al corte del rango.
        </div>
      </div>

      <div className="cg-grid-3">
        <StatCard
          title="Proveedor con más facturas ingresadas"
          main={topInv?.supplierName ? topInv.supplierName : '—'}
          subtitle={
            topInv?.supplierId
              ? `Facturas: ${topInv.count} · Total: ${formatCRC(topInv.amountTotal)}`
              : 'Sin datos'
          }
        />

        <StatCard
          title="Proveedor con más pagos procesados"
          main={topPay?.supplierName ? topPay.supplierName : '—'}
          subtitle={
            topPay?.supplierId
              ? `Pagos: ${topPay.count} · Total: ${formatCRC(topPay.amountTotal)}`
              : 'Sin datos'
          }
        />

        <StatCard
          title="Proveedor al que más se le debe (saldo)"
          main={biggest?.supplierName ? biggest.supplierName : '—'}
          subtitle={
            biggest?.supplierId
              ? `Saldo: ${formatCRC(biggest.balance)}`
              : 'Sin datos'
          }
          footer={`Saldo total por pagar (al corte): ${formatCRC(ap?.totalPayableAtEnd || 0)}`}
        />
      </div>
    </div>
  );
}
